import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class TraveltimeService {
  

  getTraveltimesForResources(events: any, resources: any, selectedDate: any) {

  // MINUTENWERTE SICHER VALIDIEREN
  const toMinutes = (value: unknown): number => {
    if (
      value === null ||
      value === undefined ||
      value === ''
    ) {
      return 0;
    }

    const minutes =
      typeof value === 'number'
        ? value
        : typeof value === 'string'
          ? Number(value.trim())
          : NaN;

    return Number.isFinite(minutes) && minutes >= 0
      ? minutes
      : 0;
  };

  // DATUM SICHER ERSTELLEN
  const toValidDate = (value: any): Date | null => {
    if (value === null || value === undefined || value === '') {
      return null;
    }

    const date = value instanceof Date
      ? value
      : new Date(value);

    return Number.isFinite(date.getTime()) ? date : null;
  };

  // EINGABEN ABSICHERN
  const safeEvents = Array.isArray(events)
    ? events.filter(
        (event: any) => event !== null && typeof event === 'object'
      )
    : [];

  const safeResources = Array.isArray(resources)
    ? resources
    : [];

  const targetDate = toValidDate(selectedDate);

  // NUR MISSION EVENTS DES AUSGEWÄHLTEN TAGES
  const missionEvents = targetDate
    ? safeEvents.filter((event: any) => {
        if (event.type !== 'MISSIONEVENT') {
          return false;
        }

        const eventDate = toValidDate(event.start);

        return eventDate !== null &&
          eventDate.getFullYear() === targetDate.getFullYear() &&
          eventDate.getMonth() === targetDate.getMonth() &&
          eventDate.getDate() === targetDate.getDate();
      })
    : [];

  // FAHRTZEITEN JE EVENT BERECHNEN
  const missionEventsWithTraveltimes = missionEvents.map(
    (event: any) => ({
      ...event,

      // REALE FAHRTZEITEN AUS BUFFERS (MINUTEN)
      traveltimeReal:
        toMinutes(event.bufferBefore) +
        toMinutes(event.bufferAfter),

      // ABRECHNUNGSZEITEN AUS OFFICE-LOCATION (MINUTEN)
      traveltimeAccounting:
        toMinutes(event.traveltimeBefore) +
        toMinutes(event.traveltimeAfter)
    })
  );

  // RESSOURCEN BEARBEITEN
  safeResources.forEach((team: any) => {
    if (!team || !Array.isArray(team.children)) {
      return;
    }

    team.children.forEach((resource: any) => {
      if (!resource || typeof resource !== 'object') {
        return;
      }

      // OHNE GÜLTIGE RESOURCE-ID KEINE ZUORDNUNG
      if (
        resource.id === null ||
        resource.id === undefined ||
        resource.id === ''
      ) {
        resource.traveltimeReal = 0;
        resource.traveltimeAccounting = 0;
        return;
      }

      // PASSENDE EVENTS DER RESSOURCE
      const resourceEvents = missionEventsWithTraveltimes.filter(
        (event: any) => {
          const eventResources = Array.isArray(event.resource)
            ? event.resource
            : event.resource !== null &&
              event.resource !== undefined
              ? [event.resource]
              : [];

          return eventResources.some(
            (id: any) => id === resource.id
          );
        }
      );

      // REALE FAHRTZEITEN IN MINUTEN SUMMIEREN
      const realtimeMinutes = resourceEvents.reduce(
        (sum: number, event: any) =>
          sum + toMinutes(event.traveltimeReal),
        0
      );

      // ABRECHNUNGSZEITEN IN MINUTEN SUMMIEREN
      const accountingMinutes = resourceEvents.reduce(
        (sum: number, event: any) =>
          sum + toMinutes(event.traveltimeAccounting),
        0
      );

      // MINUTEN IN STUNDEN UMWANDELN
      resource.traveltimeReal = Number.isFinite(realtimeMinutes)
        ? realtimeMinutes / 60
        : 0;

      resource.traveltimeAccounting = Number.isFinite(accountingMinutes)
        ? accountingMinutes / 60
        : 0;
    });
  });

  return safeResources;
}


  

}
